<div class="ui-g-12" *ngIf="type_results != 'NOTHING'">
    <div>
        <h3 class="ui-g-12 card" style="border: #edf0f5 5px solid;">
            {{'customers.selected_period' | translate}}: {{elapsedStart | date :'dd/MM/yyyy' }} - {{elapsedEnd | date :'dd/MM/yyyy' }}
        </h3>
    </div>
    <div class="ui-g-6">
        <h3></h3>
        <div class="highcharts-container">
            <chart [options]="chart_revenue.options" style="display:block;"
                   (load)="setChartInstance(chart_revenue, $event.context)"></chart>
        </div>
    </div>
    <div class="ui-g-6">
        <h3></h3>
        <div class="highcharts-container">
            <chart [options]="chart_scontrini.options" style="display:block;"
                   (load)="setChartInstance(chart_scontrini, $event.context)"></chart>
        </div>
    </div>

    <div class="ui-g-6" *ngIf="type_results == 'ALL'">
        <h3></h3>
        <div class="highcharts-container">
            <chart [options]="chart_active_customers.options" style="display:block;"
                   (load)="setChartInstance(chart_active_customers, $event.context)"></chart>
        </div>
    </div>
    <div class="ui-g-6" *ngIf="type_results =='ALL'">
        <h3></h3>
        <div class="highcharts-container">
            <chart [options]="chart_card_penetration.options" style="display:block;"
                   (load)="setChartInstance(chart_card_penetration, $event.context)"></chart>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/customerDB/revenue-analysis/trend/revenue-analysis-trend.component.html